import React from "react";

import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";
import MoodBadIcon from "@material-ui/icons/MoodBad";
import NoDataImage from "assets/images/NoData1.png";

export default ({ showImage, errorText, width, noMarginTop }) => {
  const classes = useStyles();

  return (
    <div className={classes.noData}>
      {showImage ? (
        <img
          src={NoDataImage}
          style={{
            width: width || 200,
            margin: noMarginTop ? "0px 0px 15px" : "100px 0px 15px",
          }}
        />
      ) : (
        <MoodBadIcon />
      )}
      <Typography component="p" color="textSecondary">
        {errorText ? errorText : "No Data"}
      </Typography>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  noData: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: 200,
    justifyContent: "center",
  },
}));
